export default __webpack_public_path__ + "static/media/footer.ec834302.jpg";